import ImageFileInput from "components/ImageFileInput";

export default function MyProfileRightContentPhoto({
  boxName,
  data,
  handleEvents,
  infos,
}) {
  const addClassImageCircle = data?.active === "Y" ? " active" : "";
  const photoData =
    data?.photo?.length > 0
      ? {
          url: data.photo[0]?.data_url || null,
          name: data.photo[0]?.name || null,
          isBlob: data.photo[0]?.data_url?.includes("blob:") || false,
        }
      : { url: null, name: null, isBlob: false };
  // console.log(photoData);
  return (
    <div
      className={boxName + " row"}
      id={boxName + "-upload-photo"}
      key={boxName + "-upload-photo"}
      style={{ width: "98%", margin: "0 auto", borderRadius: "10px" }}
    >
      <div id={boxName + "-inner-upload-photo"}>
        {photoData.url === null && (
          <div className={`image-circle${addClassImageCircle}`}>
            <i className="material-icons">person</i>
          </div>
        )}
        {photoData.url !== null && !photoData.isBlob && (
          <div
            className={`image-circle${addClassImageCircle}`}
            style={{
              background: "url('" + photoData.url + "') no-repeat center",
              backgroundSize: "cover",
            }}
          />
        )}
        {photoData.url !== null && photoData.isBlob && (
          <div key={"photo-0"} className={`image-circle${addClassImageCircle}`}>
            <img src={photoData.url} alt="" />
          </div>
        )}
        <div
          className="image-detail"
          style={{ paddingTop: photoData.isBlob ? "8px" : "24px" }}
        >
          <span style={{ display: "block", fontWeight: "700" }}>
            {data?.full_name ? data.full_name : ""}
          </span>
          <span
            style={{
              display: "block",
              fontWeight: "500",
              marginTop: "0px",
              color: "#5a5a5a",
            }}
          >
            {data?.position}
            {data?.dept_names ? " - " + data.dept_names.join(", ") : ""}
          </span>
          <a
            href={`https://contacts.google.com/${data?.email}`}
            target="_blank"
            rel="noreferrer"
            style={{
              display: "block",
              fontWeight: "500",
              marginTop: "0px",
            }}
          >
            {`https://contacts.google.com/${data?.email}`}
          </a>
          <span id="upload-photo-name">
            {data?.photo && (data?.photo).length > 0 ? data.photo[0].name : ""}
          </span>
        </div>
        {infos?.tabActive === "editmyprofile" && (
          <ImageFileInput
            addon={{ multiple: false }}
            handleEvents={handleEvents}
          />
        )}
      </div>
    </div>
  );
}
